import HttpClient from '../../services/HttpClient';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getBaseNewURL, getBaseURL } from 'services/getBaseURL';
import { getUserToken } from '../../services/utils';

const http = new HttpClient();
const baseURL = getBaseNewURL().wallet;
const oldBaseURL = getBaseURL().wallet;

const initialState = {
	isLoading: {
		backdrop: false,
		form: false,
		skeleton: false,
		button: false,
	},
	wallet: {},
	status: {},
	serviceWorkerUpdated: {
		status: JSON.parse(localStorage.getItem('newUpdated'))?.status || false,
		config: null,
	},
};

export const getCurrentWallet = createAsyncThunk('generalWallet', async (params, thunkAPI) => {
	const token = getUserToken(thunkAPI);
	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};
	const response = await http.post(`${baseURL}Wallet`, params, extraConfig);
	return response.data;
});

export const getStatusWallet = createAsyncThunk('statusWallet', async (params, thunkAPI) => {
	const token = getUserToken(thunkAPI);
	const extraConfig = {
		headers: {
			Authorization: token,
		},
	};
	const response = await http.post(`${oldBaseURL}/DenyRequest`, params, extraConfig, params?.isToastfy);
	return response.data;
});

const generalSlice = createSlice({
	name: 'currentWallet',
	initialState,
	reducers: {
		updateServiceWorker(state, { payload }) {
			state.serviceWorkerUpdated = payload;
			localStorage.setItem('newUpdated', JSON.stringify(payload.status));
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(getCurrentWallet.pending, (state) => {
				state.isLoading.skeleton = true;
			})
			.addCase(getCurrentWallet.fulfilled, (state, { payload }) => {
				if (payload.Success) {
					state.wallet = payload.Content;
				}
				state.isLoading.skeleton = false;
			})
			.addCase(getCurrentWallet.rejected, (state) => {
				state.isLoading.skeleton = false;
			})
			.addCase(getStatusWallet.pending, (state) => {
				state.isLoading.button = true;
				state.status = {};
			})
			.addCase(getStatusWallet.fulfilled, (state, { payload }) => {
				state.status = {
					Status: payload.Status,
					Message: payload.Message,
				};
				state.isLoading.button = false;
			})
			.addCase(getStatusWallet.rejected, (state) => {
				state.isLoading.button = false;
			});
	},
});

export const { updateServiceWorker } = generalSlice.actions;
export default generalSlice.reducer;